/**
 * Greiði signature sound — hotel service bell "ding!"
 * Uses Web Audio API (no external audio files needed).
 * Plays a bright bell strike with natural decay.
 */

let audioCtx = null;

function getCtx() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

/**
 * Play the Greiði bell — a crisp hotel desk bell "ding"
 * @param {number} volume 0–1 (default 0.35)
 */
export function playBell(volume = 0.35) {
  try {
    const ctx = getCtx();
    const now = ctx.currentTime;

    // Main bell tone (bright, metallic)
    const osc1 = ctx.createOscillator();
    osc1.type = "sine";
    osc1.frequency.setValueAtTime(2200, now);
    osc1.frequency.exponentialRampToValueAtTime(1800, now + 0.08);

    // Harmonic overtone (adds shimmer)
    const osc2 = ctx.createOscillator();
    osc2.type = "sine";
    osc2.frequency.setValueAtTime(3300, now);
    osc2.frequency.exponentialRampToValueAtTime(2700, now + 0.06);

    // Gain envelope — sharp attack, natural decay
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(volume, now);
    gain.gain.exponentialRampToValueAtTime(volume * 0.6, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.6);

    const gain2 = ctx.createGain();
    gain2.gain.setValueAtTime(volume * 0.3, now);
    gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.4);

    osc1.connect(gain).connect(ctx.destination);
    osc2.connect(gain2).connect(ctx.destination);

    osc1.start(now);
    osc1.stop(now + 0.7);
    osc2.start(now);
    osc2.stop(now + 0.5);
  } catch {
    // Silent fail — audio not supported
  }
}

export default { playBell };
